import {
	GLOBAL_NAVIGATION,
	GLOBAL_NAVIGATION_SECONDARY,
} from '@tracsis/library/src/constants/GlobalNavigation';

export const LINKS = {
	ABOUT: '/about/',
	NEWS: '/news/',
	ARCHIVE: '/archive/',
	MARKETS: '/markets/',
	SOLUTIONS: '/solutions/',
	PROJECTS: '/projects/',
	CAREERS: '/careers/',
	CONTACT: '/contact/',
	TERMS: '/terms/',
	COOKIES: '/privacy-notice/',
	STANDARD_TERMS: '/standard-terms-conditions/',
	SERVICES_FINE_PRINT: '/services-fine-print/',
	SOFTWARE_POLICY: '/software-policy-requirements/',
	RESOURCES: '/resources/',

	MARKETS_REGIONAL: '/markets/regional-short-lines/',
	MARKETS_FREIGHT: '/markets/freight-railroads/',
	MARKETS_PASSENGER_RAIL: '/markets/passenger-rail-transit-agencies/',
	MARKETS_PORTS: '/markets/ports-and-industrial/',

	SOLUTIONS_PTC: '/solutions/positive-train-control/',
	SOLUTIONS_PTC_ITCBOS:
		'/solutions/positive-train-control/interoperable-train-control-back-office-system/',
	SOLUTIONS_PTC_EATC:
		'/solutions/positive-train-control/enhanced-automatic-train-control/',
	SOLUTIONS_YA: '/solutions/yard-automation/',
	SOLUTIONS_YA_BFTP: '/solutions/yard-automation/blue-flag-track-protection/',
	SOLUTIONS_YA_RCR: '/solutions/yard-automation/remote-control-routing/',
	SOLUTIONS_YA_RHC: '/solutions/yard-automation/remote-heater-control/',
	SOLUTIONS_CAD: '/solutions/computer-aided-dispatching/',
	SOLUTIONS_CAD_CTC:
		'/solutions/computer-aided-dispatching/centralized-traffic-control/',
	SOLUTIONS_CAD_TWCDTC:
		'/solutions/computer-aided-dispatching/track-warrant-control-direct-traffic-control/',
	SOLUTIONS_CAD_DTW:
		'/solutions/computer-aided-dispatching/digital-track-warrant/',
	SOLUTIONS_SMA: '/solutions/remote-condition-monitoring/',
	SOLUTIONS_TECH: '/solutions/technical-support/',
};

export const NAVIGATION = [
	{
		to: LINKS.SOLUTIONS,
		label: 'Solutions',
		description:
			"Our innovative solutions are designed to monitor, analyze and control rail assets. Crucially, they're instrumental in providing sustainable operating efficiencies and increased safety worldwide.",
		links: [
			{
				to: LINKS.SOLUTIONS,
				label: 'View our solutions',
			},
		],
		subMenu: [
			{
				to: LINKS.SOLUTIONS_CAD,
				label: 'Computer Aided Dispatching',
				description: 'Technology that eliminates the risk of human error',
				subMenu: [
					{
						to: LINKS.SOLUTIONS_CAD_CTC,
						label: 'Centralized Traffic Control (CTC)',
					},
					{
						to: LINKS.SOLUTIONS_CAD_TWCDTC,
						label: 'Track Warrant Control (TWC) & Direct Traffic Control (DTC)',
					},
					{
						to: LINKS.SOLUTIONS_CAD_DTW,
						label: 'Digital Track Warrant',
					},
					{
						to: LINKS.SOLUTIONS_PTC,
						label: 'Positive Train Control (PTC)',
					},
				],
			},
			{
				to: LINKS.SOLUTIONS_PTC,
				label: 'Positive Train Control',
				description: 'Designed for both ITC and E-ATC.',
				subMenu: [
					{
						to: LINKS.SOLUTIONS_PTC_ITCBOS,
						label: 'Interoperable Train Control (ITC) Back Office System (BOS)',
					},
					{
						to: LINKS.SOLUTIONS_PTC_EATC,
						label: 'Enhanced Automatic Train Control (E-ATC)',
					},
				],
			},
			{
				to: LINKS.SOLUTIONS_YA,
				label: 'Yard Automation',
				description: 'Getting cars to the right destinations on time.',
				subMenu: [
					{
						to: LINKS.SOLUTIONS_YA_RCR,
						label: 'Remote Control & Routing',
					},
					{
						to: LINKS.SOLUTIONS_YA_BFTP,
						label: 'Blue Flag and Track Protection',
					},
					{
						to: LINKS.SOLUTIONS_YA_RHC,
						label: 'Remote Heater Control',
					},
				],
			},
			{
				to: LINKS.SOLUTIONS_SMA,
				label: 'Remote Condition Monitoring',
				description:
					'Discover and resolve issues before they become a problem.',
			},
			{
				to: LINKS.SOLUTIONS_TECH,
				label: 'Technical Support',
				description: 'Tailored service plans to meet your needs.',
			},
		],
	},
	{
		to: LINKS.MARKETS,
		label: 'Markets',
		description: 'Increased efficiency and safety - whatever the market.',
		links: [
			{
				to: LINKS.MARKETS,
				label: 'View our markets',
			},
		],
		subMenu: [
			{
				to: LINKS.MARKETS_REGIONAL,
				label: 'Regional and short lines',
				description: 'Reliable, flexible and user-friendly control systems.',
			},
			{
				to: LINKS.MARKETS_FREIGHT,
				label: 'Freight Railroads',
				description: 'Every North American Class 1 railroad chooses Tracsis.',
			},
			{
				to: LINKS.MARKETS_PASSENGER_RAIL,
				label: 'Passenger Rail/Transit Agencies',
				description: 'Minimal network downtime - maximum efficiency.',
			},
			{
				to: LINKS.MARKETS_PORTS,
				label: 'Ports and industrial',
				description: 'Transferring containers safely and on schedule.',
			},
		],
	},
	{
		to: LINKS.PROJECTS,
		label: 'Projects',
	},
	{
		to: LINKS.ABOUT,
		label: 'About us',
	},
	{
		to: LINKS.NEWS,
		label: 'News',
	},
	{
		to: LINKS.CONTACT,
		label: 'Contact',
	},
	{
		label: 'Our Solutions',
		globalNavigation: GLOBAL_NAVIGATION,
	},
];

export const SUB_COMPANIES = [
	{
		label: 'Tracsis Companies',
		globalNavigation: GLOBAL_NAVIGATION,
	},
	GLOBAL_NAVIGATION_SECONDARY,
].flat(1);

export const SUB_NAVIGATION = [
	{
		to: LINKS.TERMS,
		label: 'Terms and conditions',
	},
	{
		to: LINKS.COOKIES,
		label: 'Privacy notice',
	},
	{
		to: LINKS.STANDARD_TERMS,
		label: 'Standard terms & conditions',
	},
	{
		to: LINKS.SERVICES_FINE_PRINT,
		label: 'Services fine print',
	},
	{
		to: LINKS.SOFTWARE_POLICY,
		label: 'Software policy requirements',
	},
];

export const FOOTER_NAV_1 = [
	{
		to: LINKS.SOLUTIONS,
		label: 'Solutions',
	},
	{
		to: LINKS.SOLUTIONS_CAD,
		label: 'Computer Aided Dispatching',
	},
	{
		to: LINKS.SOLUTIONS_PTC,
		label: 'Positive Train Control',
	},
	{
		to: LINKS.SOLUTIONS_YA,
		label: 'Yard Automation',
	},
	{
		to: LINKS.SOLUTIONS_SMA,
		label: 'Remote Condition Monitoring',
	},
	{
		to: LINKS.SOLUTIONS_TECH,
		label: 'Technical Support',
	},
];

export const FOOTER_NAV_2 = [
	{
		to: LINKS.MARKETS,
		label: 'Markets',
	},
	{
		to: LINKS.MARKETS_FREIGHT,
		label: 'Freight Railroads',
	},
	{
		to: LINKS.MARKETS_PASSENGER_RAIL,
		label: 'Passenger Rail / Transit Agencies',
	},
	{
		to: LINKS.MARKETS_PORTS,
		label: 'Ports and industrial',
	},
	{
		to: LINKS.MARKETS_REGIONAL,
		label: 'Regional and short lines',
	},
];

export const FOOTER_NAV_3 = [
	{
		to: LINKS.ABOUT,
		label: 'About Tracsis',
	},
	{
		to: LINKS.NEWS,
		label: 'News',
	},
	{
		to: LINKS.ARCHIVE,
		label: 'Archive',
	},
	{
		to: LINKS.RESOURCES,
		label: 'Resources',
	},
	{
		to: LINKS.PROJECTS,
		label: 'Projects',
	},
];

export const FOOTER_NAV_4 = [];
export const FOOTER_NAV_5 = [];

export const SOCIAL = [
	{
		to: 'https://www.linkedin.com/company/railcomm/',
		platform: 'LinkedIn',
	},
	{
		to: 'https://x.com/railcomm',
		platform: 'X',
	},
];
